export default __webpack_public_path__ + "static/media/real-life-TOM1F.36eb288c.mp3";